import { createFileRoute } from '@tanstack/react-router';
import { PaymentMethodForm } from '@/components/payment-method/payment-method-form.tsx';
import { PaymentMethodList } from '@/components/payment-method/payment-method-list.tsx';
import { usePaymentMethods } from '@/lib/payment-methods/hooks/usePaymentMethods.ts';
import { useCallback, useRef, useState } from 'react';
import { z } from 'zod';
import { Helmet } from '@dr.pogodin/react-helmet';
import { Button } from '@/components/ui/button.tsx';
import { Plus } from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog.tsx';

const paymentMethodsSearchSchema = z.object({
  redirect: z.string().optional(),
});

export const Route = createFileRoute(
  '/_checkAuth/_layout/_authenticated/_member/_layout/miembros_/medio-de-pago',
)({
  validateSearch: paymentMethodsSearchSchema,
  component: () => <Payment />,
});

function Payment() {
  const { redirect } = Route.useSearch();
  const {
    paymentMethods,
    isLoading,
    deletePaymentMethod,
    isDeleting,
  } = usePaymentMethods();

  const [dialogOpen, setDialogOpen] = useState(false);
  const isPendingRef = useRef(false);

  const onSubmitted = useCallback(async () => {
    setDialogOpen(false);
    if (redirect) {
      window.location.replace(redirect);
    }
  }, [redirect]);

  const paymentMethod = paymentMethods[0] ?? null;
  const hasCard = !!paymentMethod;

  return (
    <>
      <Helmet>
        <title>Medio de Pago | MovieClub</title>
      </Helmet>
      <h2 className="text-xl font-bold">Medio de Pago</h2>
      <p className="text-xs text-gray-500 sm:text-sm">
        Administra tu tarjeta de crédito. Se utiliza para cobrar tu suscripción.
      </p>

      <div className="mt-4">
        <PaymentMethodList
          paymentMethod={paymentMethod}
          isLoading={isLoading}
          onDelete={deletePaymentMethod}
          isDeleting={isDeleting}
        />
      </div>

      {!hasCard && (
        <div className="mt-4 flex justify-end">
          <Button variant="outline-default" onClick={() => setDialogOpen(true)}>
            <Plus className="mr-2 h-4 w-4" />
            Agregar tarjeta
          </Button>
        </div>
      )}

      <Dialog
        open={dialogOpen}
        onOpenChange={(open) => {
          if (!open && isPendingRef.current) return;
          setDialogOpen(open);
        }}
      >
        <DialogContent className="max-w-xl overflow-hidden">
          <DialogHeader>
            <DialogTitle>Agregar tarjeta</DialogTitle>
          </DialogHeader>
          <PaymentMethodForm
            onSubmitted={onSubmitted}
            onPendingChange={(pending) => {
              isPendingRef.current = pending;
            }}
          />
        </DialogContent>
      </Dialog>
    </>
  );
}
